import TradeInAcceptanceModal from "./TradeInAcceptanceModal"
import TradeInIframeModal from "./TradeInIframeModal"
import TradeInLoaderModal from "./TradeInLoaderModal"
import React from "react"

const TradeInModals = ({showTradeInModal, showIframeModal, showLoaderModal, loaderStatus, onConfirm, onCancel, onCloseIframe, onLoaderContinue, tunnelData}) => {
  const firstProduct = tunnelData?.data?.order?.products?.[0]
  const tradeInData = {
    opl: tunnelData.opl,
    sku: firstProduct.sku,
    designation: firstProduct.designation
  }

  return (
    <>
      <TradeInAcceptanceModal showModal={showTradeInModal} onConfirm={onConfirm} onCancel={onCancel}/>

      <TradeInIframeModal
        showModal={showIframeModal}
        onClose={onCloseIframe}
        title="TradeIn"
        skuAndProduct={tradeInData}
        iframeSrc={tunnelData.data.order.tradeInIframeURL}
      />

      <TradeInLoaderModal
        showModal={showLoaderModal}
        status={loaderStatus}
        onContinue={onLoaderContinue}
        tunnelData={tunnelData}
      />
    </>
  )
}

export default TradeInModals
